import { render, staticRenderFns } from "./Combisell.vue?vue&type=template&id=b55f18ea&"
import script from "./Combisell.vue?vue&type=script&lang=js&"
export * from "./Combisell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/82/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b55f18ea')) {
      api.createRecord('b55f18ea', component.options)
    } else {
      api.reload('b55f18ea', component.options)
    }
    module.hot.accept("./Combisell.vue?vue&type=template&id=b55f18ea&", function () {
      api.rerender('b55f18ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/Combisell.vue"
export default component.exports